import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ArrowRight, Pill } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide5UKFunnel({
  index
}: SlideProps) {
  const products = [{
    name: 'Anzupgo',
    focus: 'Chronic hand eczema',
    primary: true
  }, {
    name: 'Enstilar',
    focus: 'Psoriasis',
    primary: false
  }, {
    name: 'Tralo',
    focus: 'Atopic dermatitis',
    primary: false
  }];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--surface)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-206">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-207">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-208">
          The Funnel
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.5vw,3rem)] leading-[1.1]" data-id="element-209">
          An above-brand hub that{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-210">
            routes HCPs to Anzupgo
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(1.5rem,3vw,3rem)] items-center min-h-0" data-id="element-211">
        {/* Gateway: existing non-branded DERMX content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="col-span-5 bg-white rounded-2xl p-[clamp(1.5rem,2vw,2rem)] border border-black/5 shadow-sm flex flex-col" data-id="element-212">
          <div className="flex items-center gap-3 mb-4" data-id="element-213">
            <div className="w-11 h-11 rounded-xl bg-[var(--brand-green)] flex items-center justify-center flex-shrink-0" data-id="element-214">
              <BookOpen className="w-6 h-6 text-white" data-id="element-215" />
            </div>
            <div data-id="element-216">
              <p className="text-[var(--brand-green-light)] text-xs font-bold uppercase tracking-widest" data-id="element-217">
                Portfolio Gateway
              </p>
              <h3 className="text-[var(--fg)] font-bold text-[clamp(1.1rem,1.5vw,1.4rem)] leading-tight" data-id="element-218">
                Existing DERMX content
              </h3>
            </div>
          </div>
          <p className="text-[var(--muted)] text-[clamp(0.9rem,1.1vw,1.1rem)] leading-relaxed mb-4" data-id="element-219">
            The UK can leverage DERMX's existing non-branded webinars,
            educational series and condition-focused journeys as an above-brand
            entry point — open to the whole dermatology portfolio.
          </p>
          <div className="mt-auto bg-[var(--surface)] rounded-xl p-3 border border-black/5" data-id="element-220">
            <p className="text-[var(--fg)] text-sm leading-snug" data-id="element-221">
              <span className="font-semibold" data-id="element-222">e.g.</span> “Managing chronic hand
              eczema across treatment options” — broad clinical value before any
              brand.
            </p>
          </div>
        </motion.div>

        {/* Connector */}
        <div className="col-span-1 flex justify-center" data-id="element-223">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.7,
          duration: 0.4
        }} className="w-10 h-10 rounded-full bg-[var(--brand-green)] flex items-center justify-center shadow-sm" data-id="element-224">
            <ArrowRight className="w-5 h-5 text-white" data-id="element-225" />
          </motion.div>
        </div>

        {/* Spokes: product pages, routed by clinical need */}
        <div className="col-span-6 flex flex-col gap-[clamp(0.75rem,1.5vw,1.25rem)] min-h-0" data-id="element-226">
          <p className="text-[var(--muted)] text-[clamp(0.75rem,0.95vw,0.95rem)] font-semibold uppercase tracking-wide" data-id="element-227">
            Routed to the right product by clinical need
          </p>
          {products.map((p, i) => <motion.div key={p.name} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.6 + i * 0.15,
          duration: 0.5
        }} className={`rounded-xl p-[clamp(1rem,1.4vw,1.4rem)] flex items-center gap-4 shadow-sm ${p.primary ? 'bg-[var(--brand-green)] text-white' : 'bg-white border border-black/5'}`} data-id="element-228">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${p.primary ? 'bg-white/15' : 'bg-[var(--surface)]'}`} data-id="element-229">
                <Pill className={`w-5 h-5 ${p.primary ? 'text-white' : 'text-[var(--brand-green)]'}`} data-id="element-230" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-231">
                <p className={`font-bold text-[clamp(1.05rem,1.4vw,1.35rem)] leading-tight ${p.primary ? 'text-white' : 'text-[var(--fg)]'}`} data-id="element-232">
                  {p.name}
                </p>
                <p className={`text-[clamp(0.8rem,0.95vw,0.95rem)] ${p.primary ? 'text-white/80' : 'text-[var(--muted)]'}`} data-id="element-233">
                  {p.focus}
                </p>
              </div>
              {p.primary && <span className="text-[0.65rem] font-bold uppercase tracking-wider bg-white/20 text-white px-2.5 py-1 rounded-full flex-shrink-0" data-id="element-234">
                  Target
                </span>}
            </motion.div>)}
        </div>
      </div>

      {/* Bottom statement */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.1,
      duration: 0.6
    }} className="flex justify-between items-end mt-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-235">
        <p className="text-[var(--fg)] text-[clamp(1rem,1.25vw,1.25rem)] font-semibold" data-id="element-236">
          One shared dermatologist audience, qualified by content, funnelled
          into Anzupgo-specific messaging.
        </p>
      </motion.div>
    </div>;
}